import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, grey } from '../colors';
import { GetThemeOptions } from '../../theme';
import { chronoDefinedDarkTokens, chronoDefinedLightTokens } from '@/theme/unityTokens';

export const defaultColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const tokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: tokens['--data-informative-neutral'],
      highContrast: tokens['--data-informative-neutral-high-contrast'],
      lowContrast: tokens['--data-informative-neutral-low-contrast'],
    };
  }

  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
